export default __webpack_public_path__ + "media/images/features/ambassador/profiles/chihilocal_san-2a15cec107e96731dc2caec80bb9ca27.jpg";